import styled, { keyframes } from 'styled-components/macro';

const open = keyframes`
  0% {
    transform: translate(-100%);

  }
  100% {
    transform: translate(0%);
  }
`;

const openRight = keyframes`
  0% {
    transform: translate(100%);

  }
  100% {
    transform: translate(0%);
  }
`;

const openModal = keyframes`
  0% {
    margin-top: -100px;

  }
  100% {
    margin-top: 0px;
  }
`;

const close = keyframes`
  0% {
    transform: translate(0%);

  }
  100% {
    transform: translate(-100%);
  }
`;

const closeRight = keyframes`
  0% {
    transform: translate(0%);
  }
  100% {
    transform: translate(100%);
  }
`;

const closeModal = keyframes`
 
`;

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

const chooseAnimation = ({ zone, animation }) => {
  switch (zone) {
    case 'right':
      return animation === 'open' ? openRight : closeRight;
    case 'left':
      return animation === 'open' ? open : close;
    case 'whole':
      return animation === 'open' ? openModal : closeModal;
    default:
      return animation === 'open' ? fadeIn : fadeOut;
  }
};

export const Container = styled.div`
  display: flex;
  max-width: ${({ fullWidth }) => (fullWidth ? '100%' : '648px')};
  position: ${({ zone }) => (zone === 'whole' ? `fixed` : 'absolute')};
  ${({ fullWidth }) =>
    fullWidth
      ? `
    width: 100%;
  `
      : null}
  animation: ${props => chooseAnimation(props)} 0.2s;
  ${({ zone }) => (zone !== 'whole' ? `height: 100%;` : '')}
  z-index: 99;
  ${({ zone }) => (zone === 'right' ? `right: 0px; top: 0px;` : '')}
  ${({ zone }) => (zone === 'left' ? `left: 0px; top: 0px;` : '')}
  ${({ zone }) =>
    zone === 'whole'
      ? `
    top: 50%;
    left: 50%;
    transform: translate( -50%, -50%);
    max-height:90%;
  `
      : ''}
  @media (max-width: ${({ theme }) => `${theme.breakpoints.sm}px`}) {
    max-height:100%;
    width: 100%;
  }

`;

export const OpacityLayer = styled.div`
  position: ${({ zone }) => (zone === 'whole' ? 'fixed' : 'absolute')};
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: -1;
  left: 0px;
  top: 0px;
  z-index: 98;
  cursor: pointer;
`;
